const home = {
  hero: {
    badge: "Centro de recursos independiente",
    title: "Hoja de cálculo de USFans: Encuentra, Compara y Explora Recursos",
    subtitle: "Explora la hoja de cálculo de USFans, categorías de productos, información de vendedores, guías de envío, reseñas, cupones, detalles del almacén y herramientas prácticas de investigación — todo organizado en un centro de recursos fácil de usar.",
    searchPlaceholder: "Busca productos, vendedores, envíos o guías...",
    trust: "Recurso independiente · Guías actualizadas · Multilingüe · Centrado en la seguridad",
    primaryCta: "Explorar hoja de cálculo de USFans",
    secondaryCta: "Visitar sitio principal",
    supportTitle: "¿Buscas una hoja de cálculo de USFans?",
    supportText: "Encuentra recursos organizados, guías de investigación, comparaciones e información práctica para ayudarte a entender USFans antes de tomar una decisión.",
    explore: [
      "Recursos de la hoja de cálculo",
      "Investigación de productos",
      "Información de vendedores",
      "Costos de envío",
      "Guías del almacén",
      "Reseñas",
      "Cupones y descuentos",
      "Consejos de seguridad",
    ],
  },
  cta: {
    exploreSpreadsheet: "Explorar hoja de cálculo",
    usfansSpreadsheet: "Hoja de cálculo USFans",
    buyItNow: "Comprar ahora",
    visitMain: "Visitar sitio principal",
    exploreAll: "Explorar todos los recursos",
    continueMain: "Continuar al sitio principal",
  },
  categories: {
    title: "Explora las categorías de productos",
    subtitle: "Elige una categoría a continuación para ver los últimos productos disponibles en el sitio principal.",
    dropdownLabel: "Selecciona una categoría",
    dropdownPlaceholder: "Elige una categoría de producto...",
    items: {
      shoes: "Zapatos",
      hoodies: "Sudaderas / Jerseys",
      tshirts: "Camisetas",
      jackets: "Chaquetas",
      pants: "Pantalones / Cortos",
      headwear: "Gorros",
      sets: "Conjuntos",
      underwear: "Ropa interior",
      jersey: "Camiseta deportiva",
      accessories: "Accesorios",
      bags: "Bolsos",
      belts: "Cinturones",
      perfumes: "Perfumes",
      other: "Otras cosas",
    },
  },
  resources: {
    title: "Recursos populares",
    subtitle: "Todo lo que necesitas para investigar USFans, organizado en temas sencillos.",
    items: [
      { title: "Hoja de cálculo USFans", desc: "Explora recursos, listas y guías de investigación de la hoja de cálculo." },
      { title: "Reseña de USFans", desc: "Comprende funciones, ventajas, limitaciones y consideraciones." },
      { title: "Costo de envío de USFans", desc: "Aprende qué afecta los costos de envío y cómo comparar opciones." },
      { title: "Almacén de USFans", desc: "Comprende el almacenamiento, el procesamiento y consideraciones relacionadas." },
      { title: "Cupón y código de descuento", desc: "Encuentra información actual de cupones y descuentos cuando esté disponible." },
      { title: "¿Es legítimo USFans?", desc: "Lee nuestra guía independiente de seguridad y legitimidad." },
    ],
  },
  hub: {
    title: "Tu centro de recursos de la hoja de cálculo USFans",
    copy: "USFansSheet.live organiza los recursos de la hoja de cálculo de USFans en categorías con buscador para que pases menos tiempo buscando y más tiempo investigando.",
    cards: ["Listas de la hoja", "Investigación de productos", "Investigación de vendedores", "Envío", "Almacén", "Reseñas", "Cupones", "Seguridad"],
  },
  why: {
    title: "Todo lo que necesitas para investigar USFans en un solo lugar",
    items: [
      { title: "Organizado", desc: "Encuentra información relacionada de la hoja de cálculo USFans sin saltar entre páginas sin relación." },
      { title: "Práctico", desc: "Las guías se centran en preguntas reales que la gente realmente busca." },
      { title: "Actualizado", desc: "La información importante muestra fechas de publicación y actualización." },
      { title: "Transparente", desc: "Distingue claramente hechos verificados, análisis editorial e información que puede cambiar." },
      { title: "Multilingüe", desc: "Disponible en inglés, polaco, español y francés." },
    ],
  },
  comparison: {
    title: "Recursos de USFans comparados",
    subtitle: "Un vistazo rápido a lo que cada recurso te ayuda a aprender y para quién es mejor.",
    headers: ["Tema", "Qué puedes aprender", "Ideal para"],
    rows: [
      ["Hoja de cálculo", "Listas, productos e investigación", "Investigación de productos"],
      ["Reseña", "Funciones y limitaciones", "Principiantes"],
      ["Costo de envío", "Factores de costo y opciones", "Investigación de envío"],
      ["Almacén", "Almacenamiento y procesamiento", "Usuarios actuales"],
      ["Cupón", "Promociones disponibles", "Ahorrar dinero"],
      ["Guía de legitimidad", "Seguridad y verificación", "Conciencia de riesgo"],
    ],
  },
  guides: {
    title: "Últimas guías",
    subtitle: "Lee nuestras guías y artículos originales, escritos de forma independiente.",
    readGuide: "Leer guía",
    readArticle: "Leer artículo",
    comingSoon: "Próximamente",
    updatedLabel: "Actualizado",
  },
  articleSection: {
    title: "Artículos de la hoja de cálculo USFans",
    subtitle: "Guías originales y detalladas para ayudarte a investigar y entender USFans.",
    cardTitle: "¿Qué es la hoja de cálculo de USFans?",
    cardDesc: "Una guía completa y fácil para principiantes sobre cómo funciona la hoja de cálculo de USFans, cómo buscarla y cómo mantenerse seguro.",
    readMore: "Leer la guía completa",
  },
  safety: {
    title: "Investiga antes de comprar",
    copy: "Los recursos en línea pueden cambiar. Los enlaces, vendedores, precios, condiciones de envío y promociones no siempre están actualizados. Verifica siempre la información importante antes de hacer pagos o compartir información personal.",
    cta: "Leer la guía de seguridad de USFans",
  },
  mainCta: {
    title: "¿Listo para explorar más?",
    copy: "Usa nuestras guías y recursos de la hoja de cálculo USFans como punto de partida, y luego continúa al sitio principal para la información más reciente disponible.",
  },
  faq: {
    title: "Preguntas frecuentes",
    items: [
      { q: "¿Qué es la hoja de cálculo de USFans?", a: "La hoja de cálculo de USFans es un recurso organizado y con buscador que lista y compara productos, categorías, vendedores e información de investigación relacionada. Ayuda a los compradores a encontrar lo que buscan más rápido." },
      { q: "¿Cómo funciona la hoja de cálculo de USFans?", a: "Agrupa productos e información en categorías para que puedas navegar, buscar y comparar opciones en un solo lugar en lugar de visitar muchas páginas separadas." },
      { q: "¿Es legítimo USFans?", a: "Ofrecemos orientación independiente para ayudarte a verificar información, pero no podemos garantizar la legitimidad de ningún vendedor. Investiga siempre con cuidado y consulta la información actual antes de comprar." },
      { q: "¿Cuánto cuesta el envío de USFans?", a: "Los costos de envío pueden cambiar según la ubicación, el método y el vendedor. Explicamos los factores que afectan el envío para que puedas comparar opciones tú mismo." },
      { q: "¿USFans ofrece cupones?", a: "Las promociones y cupones pueden estar disponibles en ciertos momentos. Describimos cómo buscar ofertas actuales, pero no publicamos códigos de descuento garantizados ni sin verificar." },
      { q: "¿Dónde encuentro códigos de descuento de USFans?", a: "Busca siempre códigos en el sitio principal oficial o en canales verificados. Ten cuidado con códigos no oficiales que puedan estar desactualizados o ser engañosos." },
      { q: "¿Qué es el almacén de USFans?", a: "El almacén se relaciona con cómo se almacenan y procesan los productos antes del envío. Explicamos el concepto general y las cosas a considerar." },
      { q: "¿Es oficial la hoja de cálculo de USFans?", a: "USFansSheet.live es un recurso informativo independiente y no está necesariamente afiliado a ni respaldado por USFans." },
      { q: "¿Cómo verifico la información?", a: "Compara los detalles en el sitio principal, revisa las actualizaciones recientes y confirma precios, envío y disponibilidad antes de hacer pagos o compartir datos personales." },
      { q: "¿Con qué frecuencia se actualizan los recursos?", a: "Intentamos mantener la información actualizada, pero los detalles pueden cambiar rápido. Consulta siempre el sitio principal para la información más reciente." },
    ],
  },
};

export default home;